import api from "@/api.js";

export default {
  state: {
    organizations: [],
    organizationsLoading: false,
    organizationsSurveys: [],
    organizationsSurveysLoading: false
  },
  mutations: {
    setOrganizations(state, payload) {
      state.organizations = payload;
    },
    setOrganizationsLoading(state, payload) {
      state.organizationsLoading = payload;
    },
    setOrganizationsSurveys(state, payload) {
      state.organizationsSurveys = payload;
    },
    setOrganizationsSurveysLoading(state, payload) {
      state.organizationsSurveysLoading = payload;
    }
  },
  actions: {
    async loadOrganizations({ commit }) {
      commit("setOrganizationsLoading", true);
      let organizations = await api.get("organizations");
      commit("setOrganizations", organizations.data);
      commit("setOrganizationsLoading", false);
    },
    async loadOrganizationsSurveys({ commit }, id) {
      commit("setOrganizationsSurveysLoading", true);
      let organizations = await api.get("organizations/surveys", {
        params: {
          id: id
        }
      });
      commit("setOrganizationsSurveys", organizations.data);
      commit("setOrganizationsSurveysLoading", false);
    },
    async newOrganization({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("organizations", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadOrganizations");
      return returnData;
    },
    async saveOrganization({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`organizations`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadOrganizations");
      return returnData;
    },
    async organizationAddSurvey({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`organizations/addSurvey`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadOrganizationsSurveys", payload.organizations_id);
      return returnData;
    },
    async organizationRemoveSurvey({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`organizations/removeSurvey`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadOrganizationsSurveys", payload.organizations_id);
      return returnData;
    },
    async saveOrganizationSurveysBatch({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`organizations/saveOrganizationsSurveysBatch`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    },
    async organizationExportSurveyBatch({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`organizations/exportCSVBatch`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      return returnData;
    }
  },
  getters: {
    organizations(state) {
      return state.organizations;
    },
    organizationsLoading(state) {
      return state.organizationsLoading;
    },
    organizationsSurveys(state) {
      return state.organizationsSurveys;
    },
    organizationsSurveysLoading(state) {
      return state.organizationsSurveysLoading;
    }
  }
};
